import { render, staticRenderFns } from "./safetyHealthyTargetTeam.vue?vue&type=template&id=23c59b81"
import script from "./safetyHealthyTargetTeam.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c59b81')) {
      api.createRecord('23c59b81', component.options)
    } else {
      api.reload('23c59b81', component.options)
    }
    module.hot.accept("./safetyHealthyTargetTeam.vue?vue&type=template&id=23c59b81", function () {
      api.rerender('23c59b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyTargetTeam.vue"
export default component.exports